import { render, staticRenderFns } from "./LabsSwitch.vue?vue&type=template&id=71e7b544"
import script from "./LabsSwitch.vue?vue&type=script&lang=js"
export * from "./LabsSwitch.vue?vue&type=script&lang=js"
import style0 from "./LabsSwitch.vue?vue&type=style&index=0&id=71e7b544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports